module.exports = __webpack_public_path__ + "img/refresh.df873fb5.svg";